module.exports = __webpack_public_path__ + "img/img-18.1dda5a75.png";